import { useEffect, useRef, useState } from 'react';

export function useBlobUrl(key: string, load: () => Promise<Blob>) {
  const [url, setUrl] = useState<string>();
  const [error, setError] = useState<unknown>();
  const loader = useRef(load);
  loader.current = load;

  useEffect(() => {
    let done = false;
    let created: string | undefined;

    setUrl(undefined);
    setError(undefined);
    if (!key) return;

    loader
      .current()
      .then((blob) => {
        if (done) return;
        created = URL.createObjectURL(blob);
        setUrl(created);
      })
      .catch((cause: unknown) => {
        if (!done) setError(cause);
      });

    return () => {
      done = true;
      if (created) URL.revokeObjectURL(created);
    };
  }, [key]);

  return { url, error };
}
